
import { Vue, Component } from "vue-property-decorator";
import api from "@/api/index";
import {OrganizationUnitDto, ProfitReportStandardDto, ProfitType} from "@/api/appService";
const ouKey = "Abp-OrganizationUnitId";
import Cookies from "js-cookie";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import ReportTable from "@/views/report/component/report-table.vue";
import ReportTip from "@/views/report/component/report-tip.vue";
export const getOu = () => Cookies.get(ouKey);
@Component({
  components: {ReportTip, ReportTable, ExportTableHtml}
})
export default class ProjectDetail extends Vue {
  detail: ProfitReportStandardDto[] = [];
  bigAreaList:OrganizationUnitDto[] = [];
  month: Number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  queryForm: any = {
    year: undefined,
    organizationUnitId: undefined,
    orgs: []
  };
  loading = false

  get profitType(){
    return ProfitType.BigArea;
  }

  get showOrganizationUnitChoose(){
    return (this.$store.getters['user/ou'] as OrganizationUnitDto).level === '总部';
  }

  async created() {
    this.queryForm.year = new Date().getFullYear();
    let currentOu = (this.$store.getters['user/ou'] as OrganizationUnitDto);
    if(currentOu.level!=='总部'){
      this.queryForm.organizationUnitId = currentOu.id;
    } else {

    }


    await api.organizationUnit
      .getOrganizationUnitsOfDescendant({})
      .then(res => {
        this.bigAreaList = res.filter(s=>!s.parentId);
      });

    if(this.queryForm.organizationUnitId){
      await this.fetchDetail();
    }


  }

  async fetchDetail() {
    this.loading = true;
    await api.profitReport
      .getProfitOfBigArea({
        year: this.queryForm.year,
        organizationUnitId: this.queryForm.organizationUnitId
      })
      .then(res => {
        this.detail = res;
        this.loading = false;
      });
  }

  // 搜索
  async handleSearch() {
    await this.fetchDetail();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      year: new Date().getFullYear(),
      organizationUnitId: Number(getOu())
    };
    await this.fetchDetail();
  }


  back() {
    this.$router.go(-1);
  }
}
